import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    info: {},
    loading: false,
    hasErrors: false,
    errorMsg: '',
    tokenExpired: false
}

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        onLoginInit: (state) => {
            state.loading = true
            state.hasErrors = false
        },
        onLoginSuccess: (state, action) => {
            state.info = action.payload
            state.loading = false
            state.hasErrors = false
        },
        onLoginFailure: (state) => {
            state.loading = false
            state.hasErrors = true
        },
        setErrorMsg: (state, action) => {
            state.errorMsg = action.payload
            state.hasErrors = true
        },
        resetErrorMsg: (state) => {
            state.errorMsg = ''
            state.hasErrors = false
        },
        resetInfo: (state) => {
            state.info = {}
        },
        resetAllUserInfo: (state) => {
            state.info = {}
            state.loading = false
            state.hasErrors = false
            state.errorMsg = ''
            state.tokenExpired = false
        },
        handleTokenState: (state, action) => {
            if (action.payload === true) {
                state.info = {}
            }
            state.tokenExpired = action.payload
        }
    }
})

export const { onLoginInit,onLoginSuccess,onLoginFailure, setErrorMsg, resetErrorMsg, resetInfo, handleTokenState, resetAllUserInfo } = userSlice.actions
export default userSlice.reducer